<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png">
  <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <router-view />
    <!--创建彈框--->
    <DtartedDialog v-if="$store.getters.startedDialogVisible" @success="()=>{successType = 1}" />
    <!--创建成功弹框-->
    <CreatSuccessDialog v-if="$store.getters.createSuccessVisible">
      <template v-if="successType == 1" v-slot:successCreate>
        <img src="./assets/img/client/login/pic_email.png" width="300px" height="200px">
        <p class="boldFont">Welcome to Flexshipping!</p>
        <div class="grayFont">You're just one step away from seamless freight comparison</div>
        <div class="grayFont margin8">Please check kehu@email.com to verify your account.</div>
        <div class="blueFont" style="cursor: pointer;" @click="send">Resend email</div>
      </template>
      <template v-if="successType == 2" v-slot:successLogin>
        <img src="./assets/img/client/login/pic_email_2.png" width="300px" height="200px">
        <div class="boldFont margin8">Check your email</div>
        <div class="grayFont">We've sent an email to {{ resetEmail }}</div>
        <div class="grayFont margin8">Click on the link to reset your password.</div>
        <div class="grayFont">Can’t find your email? Check your spam folder.</div>
      </template>
    </CreatSuccessDialog>
    <!--登录弹框-->
    <LoginDialog v-if="$store.getters.loginDialogVisible" @success="()=>{successType = 2}" />
    <!--聊天框-->
    <!-- <ChatDialog v-if="$store.getters.chatDialogVisible"></ChatDialog> -->
  </div>
</template>

<script>
import {
  SendActivateEmail,
  GetCurrCustomer
} from 'api/user.js'
import DtartedDialog from './client/login/startedDialog.vue'
import CreatSuccessDialog from './client/login/CreatSuccessDialog.vue'
import LoginDialog from './client/login/LoginDialog.vue'
import ChatDialog from './client/home/chatBox/index.vue'
export default {
  name: 'App',
  components: {
    DtartedDialog,
    CreatSuccessDialog,
    LoginDialog,
    ChatDialog
  },
  data() {
    return {
      successType: 1,
      resetEmail: ''
    }
  },
  created() {

  },
  mounted() {
  	this.resetEmail = localStorage.getItem('resetEmail')
  },
  methods: {
    send() {
      GetCurrCustomer().then(res => {
        if (res.code === 200) {
          SendActivateEmail(res.data.id)
        }
      })
    }
  }
}
</script>

<style>
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}
</style>
